//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'SSDAI',
  data () {
    return {
      form: {
        data1: '0',
        data2: '0',
        data3: '0',
        data4: '0',
        data5: '0',
        data6: '0',
        data7: '0',
        data8: '0',
        data9: '0',
        data10: '0'
      },
      form1: {
        data1: 1,
        data2: 1,
        data3: 1,
        data4: 3,
        data5: 2,
        data6: 1,
        data7: 2,
        data8: 4,
        data9: 3,
        data10: 2
      },
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (Number(form[key])) {
            result += Number(this.form1[key])
          }
        }
      }
      if (result > 0) {
        self.hasScore = true
      } else {
        self.hasScore = false
      }
      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/SSDAI.vue